import {
    BroadcastEventListener,
    IConnectionOptions,
    ISignalRConnection,
    SignalR
} from "ng2-signalr";
import { BehaviorSubject, Subscription } from "rxjs";
import { MsgBusConnectConfig, MsgBusProvider } from "./msg-bus-provider";

interface MsgBusListeners {
  eventName: string;
  broadcast: BroadcastEventListener<string>;
  subscription: Subscription;
}

export class OldSignalRProvider implements MsgBusProvider {
  private _connection: ISignalRConnection;
  public SensorID: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  // soundplayerwindow stuff
  private listeners: { [eventName: string]: MsgBusListeners } = {};
  constructor(private _signalR: SignalR) {}

  async connect(config: MsgBusConnectConfig): Promise<void> {
    var signalrConfig: IConnectionOptions = {
      url: config.url,
      qs: config.query,
      hubName: config.hubName,
    };

    if (config.token) {
      signalrConfig.qs.token = config.token;
    }

    this._connection = await this._signalR.connect(signalrConfig);
    await this._connection.start();
  }

  subscribe<T = any>(eventName: string, callback: (arg: T) => void): void {
    var broadcast: BroadcastEventListener<string> = this._connection.listenFor(
      eventName
    );
    var subscription = broadcast.subscribe((raw: string) => {
        let parsed;
        try {
            if (typeof raw === 'string'){
                parsed = JSON.parse(raw);
            }
            else{
                parsed = raw;
            }
        }
        catch(err){
            console.error(`[Msg-Bus-Provider] Json parsed Failed`, raw);
            return;
        }
        callback(parsed as T);
    });
    this.listeners[eventName] = {
      eventName,
      broadcast,
      subscription,
    };
  }
  unsubscribe(eventName: string): void {
    this.listeners[eventName]?.subscription.unsubscribe();
  }

  disconnect(): void {
    Object.values(this.listeners).forEach((l) => {
      this.unsubscribe(l.eventName);
      this._connection?.stopListening(l.broadcast);
    });
    this._connection?.stop();
  }
}
